import React, { Component } from 'react';
import Breadcrumb from '../../Breadcrumb';
import Icon from '../../../icons/Icon';
import { AnimatedButton } from '@trlogic/ui-pack';
import { query, repository, subscribe } from '@trlogic/client-js';
import { AlertStatus, WatchlistAlertDomains } from '../../../domain/watchlist/WatchlistAlertDomains';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import CustomLoading from '../../custom/CustomLoading';
import WatchlistAlertRequestListComponent from './WatchlistAlertRequestListComponent';
import WatchlistService from '../../../service/WatchlistService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import NavigationUtil from '../../../util/NavigationUtil';
import { ConfirmPopup } from 'primereact/confirmpopup';
import { WatchlistIndividualRecord, WatchlistIndividualRequest, WatchlistListsModel } from '../../../domain/watchlist/WatchlistDomains';
import ComponentName from '../../../constant/ComponentName';
import FolderService from '../../../service/FolderService';
import { RootState, store } from '../../../redux/store';
import { initialPagePath, PageState } from '../../../redux/reducers/PageReducer';
import { enterComponent, leaveComponent } from '../../../redux/actions/ComponentActions';
import { clearPage } from '../../../redux/actions/PageActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { CustomerRequest, WatchlistCustomerDomains } from '../../../domain/watchlist/WatchlistCustomerDomains';
import { WatchlistType } from '../../../constant/Constants';
import WatchlistInformationComponent from '../watchlist/WatchlistInformationComponent';
import CustomTabv2 from '../../custom/CustomTabv2';
import WatchlistNewsComponent from '../watchlist/WatchlistNewsComponent';
import WatchlistAlertSocialMediaComponent from './WatchlistAlertSocialMediaComponent';
import WatchlistSearchCriteriaModalComponent from '../detail/modal/WatchlistSearchCriteriaModalComponent';
import _ from 'lodash';
import WatchlistReportComponent from '../detail/pdf/WatchlistReportComponent';
import { PDFDownloadLink } from '@react-pdf/renderer';
import WatchlistAlertCommentComponent from './WatchlistAlertCommentComponent';
import WatchlistAlertCloseComponent from './close/WatchlistAlertCloseComponent';
import WatchlistReasonModalComponent from '../detail/modal/WatchlistReasonModalComponent';
import moment from 'moment/moment';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../custom/FormicaSearchSelectBox';
import CollectionNames from '../../../constant/CollectionNames';
import { User } from '../../../domain/rbac/RbacDomains';
import MessageUtil from '../../../util/MessageUtil';
import WatchlistLevelModalComponent from '../detail/modal/WatchlistLevelModalComponent';
import eq = query.eq;
import empty = query.empty;
import LanguageUtil from '../../../util/LanguageUtil';
import WatchlistAlertAuditComponent from './WatchlistAlertAuditComponent';
import WatchlistAlertHistoryComponent from './WatchlistAlertHistoryComponent';

class WatchlistAlertDetailComponent extends Component<Props, State> {
  public state: State = new State();

  private computation: subscribe.Computation | undefined;
  private kycLogSubscription: subscribe.Subscription | undefined;
  private userSubscription: subscribe.Subscription | undefined;

  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);
  private readonly repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);

  public render() {
    const {
      kycLogData,
      searchCriteriaVisible,
      type,
      watchlistResponse,
      commentModalVisible,
      commentCount,
      status,
      alertCloseModalVisible,
      levelModalVisible,
      reasonVisible,
      date,
    } = this.state;
    if (kycLogData == undefined) {
      return <CustomLoading />;
    }
    const { router } = this.props;
    const searchParams = new URLSearchParams(router.params.id);
    const alertId = searchParams.get('id') ?? kycLogData.id ?? null;
    kycLogData.request.id = alertId;
    return (
      <div className={'h-full w-full'}>
        <Breadcrumb />
        <ConfirmPopup />
        <div className='w-full px-5 py-5'>
          <div className={'flex w-full justify-between'}>
            <div className={'flex'}>
              <span
                key={'icon'}
                className='w-[60px] h-[60px] min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE]'
              >
                {this.getImage()}
              </span>
              <div className={'flex flex-col justify-center pl-3'}>
                <span className={'text-[24px] 2xl:text-4xl font-normal'}>{kycLogData?.request.name}</span>
                <div className={`flex items-center gap-x-2`}>
                  <div className={'flex w-[150px]'}>
                    <FormicaSearchSelectBox
                      ghost
                      value={`${kycLogData?.metadata?.assignee}` || '*Unassigned*'}
                      options={this.getUserOptions()}
                      customSize={'small'}
                      onChange={(e: FormicaSelectBoxItem) => this.assignAlert(e)}
                      placeholder={
                        kycLogData?.metadata?.assignee || LanguageUtil.get({ id: 'common.input.placeholder.unassigned', defaultMessage: '*Unassigned*' })
                      }
                    />
                  </div>
                  {this.getCategory()?.map((value: string, index: number) => {
                    return (
                      <span
                        key={index}
                        className={`flex min-w-[60px] text-xs shrink-0 2xl:text-md py-1 justify-center px-[8px] items-center rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                      >
                        {value}
                      </span>
                    );
                  })}
                  <span
                    className={`flex min-w-[60px] text-sm shrink-0 2xl:text-md py-1 justify-center items-center px-[8px] rounded-[50px] ${this.getStatusItem(kycLogData?.status)}`}
                  >
                    {this.getStatusText(kycLogData.status)}
                  </span>
                  <span
                    className={`flex min-w-[60px] text-xs shrink-0 2xl:text-md py-1 justify-center items-center px-[8px] rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                  >
                    {date}
                  </span>
                  <span
                    className={`flex min-w-[60px] text-xs shrink-0 2xl:text-md py-1 justify-center items-center px-[8px] rounded-[50px] bg-[#DBFFEA] text-[#027A48]`}
                  >
                    {kycLogData?.score || 0}/100
                  </span>
                  {kycLogData?.metadata?.reason && (
                    <div className={'flex gap-x-1 cursor-pointer'} onClick={() => this.setState({ reasonVisible: true })}>
                      <span className={'text-[14px] underline text-normal text-[#458EF7]'}>
                        {LanguageUtil.get({ id: 'common.label.reason', defaultMessage: 'Reason' })}
                      </span>
                    </div>
                  )}
                  {kycLogData?.results[kycLogData.results.length - 1]?.level != undefined && (
                    <div className={'flex gap-x-1 cursor-pointer'} onClick={() => this.setState({ levelModalVisible: true })}>
                      <span className={'text-[14px] underline text-normal text-[#458EF7]'}>
                        {LanguageUtil.get({ id: 'common.label.level', defaultMessage: 'Level' })}
                      </span>
                    </div>
                  )}
                  <div className={'flex gap-x-1 cursor-pointer'} onClick={() => this.setState({ searchCriteriaVisible: true })}>
                    <span className={'text-[14px] underline text-normal text-[#458EF7]'}>
                      {LanguageUtil.get({ id: 'common.label.searchCriteria', defaultMessage: 'Search Criteria' })}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className={'flex gap-x-2 items-center justify-center'}>
              <PDFDownloadLink
                document={
                  <WatchlistReportComponent
                    selectedResponse={kycLogData?.results[kycLogData.results.length - 1] || []}
                    watchlistResponse={watchlistResponse}
                    type={type as WatchlistType}
                    name={kycLogData?.request?.name}
                    request={kycLogData.request}
                  />
                }
                fileName='watchlist.pdf'
              >
                {({ blob }) => {
                  if (blob) {
                    return (
                      <div
                        style={{ boxShadow: '1px 1px 2px 0px #0000000D' }}
                        className={`cursor-pointer relative hover:bg-[#EDEDED] group w-10 h-10 box-border flex items-center justify-center rounded-[5px] border-[1px]`}
                      >
                        <Icon icon={'export'} className={'text-f-black-2'} size={20} />
                        <p
                          className={
                            'hidden group-hover:inline-flex absolute top-[-40px] w-[85px] items-center justify-center right-0 bg-[#111111]  shrink-0 text-white px-2 py-2 rounded-[8px]'
                          }
                        >
                          {LanguageUtil.get({ id: 'common.label.report', defaultMessage: 'Report' })}
                        </p>
                      </div>
                    );
                  }
                }}
              </PDFDownloadLink>
              <div
                style={{ boxShadow: '1px 1px 2px 0px #0000000D' }}
                className={`cursor-pointer bg-[#EFF2FE] relative hover:bg-[#EDEDED] group w-10 h-10 box-border flex items-center justify-center rounded-[5px] border-[1px]`}
                onClick={() => this.setState({ commentModalVisible: true })}
              >
                <Icon icon={'comment'} className={'text-[#728EFF]'} size={20} />
                {commentCount > 0 && (
                  <div className='absolute -top-2 -right-2 bg-f-blue-3 border text-white font-medium text-4xs rounded-full w-3.5 h-3.5 p-2.5 flex items-center justify-center'>
                    {commentCount > 99 ? '99+' : commentCount}
                  </div>
                )}
                <p
                  className={
                    'hidden group-hover:inline-flex absolute top-[-40px] w-[85px] items-center justify-center right-0 bg-[#111111]  shrink-0 text-white px-2 py-2 rounded-[8px]'
                  }
                >
                  Comment
                </p>
              </div>
              <AnimatedButton
                icon={'check'}
                text={LanguageUtil.get({ id: 'common.button.notMatch', defaultMessage: 'Not Match' })}
                customType={'not-fraud'}
                onClick={() => this.closeKycLog(AlertStatus.NOT_MATCH)}
              />
              <AnimatedButton
                icon={'close'}
                text={LanguageUtil.get({ id: 'common.button.match', defaultMessage: 'Match' })}
                customType={'fraud'}
                onClick={() => this.closeKycLog(AlertStatus.MATCH)}
              />
            </div>
          </div>
        </div>
        <div className={'flex w-full h-full'}>
          <CustomTabv2 tab={this.getTabs()} />
        </div>
        <WatchlistSearchCriteriaModalComponent
          visible={searchCriteriaVisible}
          request={kycLogData.request}
          onClose={() => this.setState({ searchCriteriaVisible: false })}
        />
        <WatchlistReasonModalComponent visible={reasonVisible} reason={kycLogData.metadata.reason} onClose={() => this.setState({ reasonVisible: false })} />
        <WatchlistAlertCommentComponent
          commentModalVisible={commentModalVisible}
          kycLogData={kycLogData}
          closeCommand={() => this.setState({ commentModalVisible: false })}
          setCommentCount={(count) => this.setState({ commentCount: count })}
        />
        <WatchlistAlertCloseComponent
          status={status}
          alertCloseModalVisible={alertCloseModalVisible}
          request={kycLogData.request}
          response={kycLogData.results}
          closeModel={() => this.setState({ alertCloseModalVisible: false })}
        />
        <WatchlistLevelModalComponent
          visible={levelModalVisible}
          type={type}
          level={kycLogData.results[kycLogData.results.length - 1]?.level}
          onClose={() => this.setState({ levelModalVisible: false })}
        />
      </div>
    );
  }

  public componentDidMount = async () => {
    const {
      router: { location },
    } = this.props;
    const page = store.getState().page;
    const initial = initialPagePath[ComponentName.WATCHLIST_ALERT];
    if (page.pagePath.length == 0 || page.pagePath[0].title != initial?.title) {
      await FolderService.calculate('WITHOUT_FOLDER', ComponentName.WATCHLIST_ALERT, location.pathname, store.getState().page);
    }
    this.setState({ date: moment().format('DD/MM/yyyy HH:mm').valueOf() });
    await this.getLists();
    await this.goAlert();
    await this.startTracker();
  };

  public componentWillUnmount = async () => {
    await this.stopTracker();
  };

  private startTracker = async () => {
    const { router } = this.props;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const id: string | null = previousSearchParams.get('id');
    const type: string | null = previousSearchParams.get('type');
    if (type == null || id == null) return;
    const endpoint = `kyc_${type.toLowerCase()}_log_${NavigationUtil.getTenant()}`;
    const userQuery: query.Query = query.QueryBuilder.select().from(CollectionNames.USERS).where(empty()).select('username', 'firstName', 'lastName').build();
    this.userSubscription = subscribe.Formica.subscribe(CollectionNames.USERS, userQuery);
    this.kycLogSubscription = subscribe.Formica.subscribe(endpoint, this.getQuery(), undefined, 'elasticsearch');
    this.computation?.addSubscription(this.kycLogSubscription);
    this.computation = subscribe.Tracker.autorun(this.tracker, [this.kycLogSubscription, this.userSubscription]);
  };

  private tracker = async () => {
    if (this.kycLogSubscription?.ready()) {
      this.fetchKycLog();
    }
  };

  private stopTracker = async () => {
    await this.userSubscription?.stop();
    await this.kycLogSubscription?.stop();
    await this.computation?.stop();
  };

  private fetchKycLog = async () => {
    const { router } = this.props;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const id: string | null = previousSearchParams.get('id');
    const type: string | null = previousSearchParams.get('type');
    if (type == null || id == null) return;
    const userQuery: query.Query = query.QueryBuilder.select().from(CollectionNames.USERS).build();
    const users: User[] = await this.repository.findMany(userQuery);
    const endpoint = `kyc_${type.toLowerCase()}_log_${NavigationUtil.getTenant()}`;
    let kycLogData: WatchlistAlertDomains | undefined = await this.repository.find<WatchlistAlertDomains>(
      query.QueryBuilder.select().where(eq('id', id)).from(endpoint).build(),
    );
    this.setState({ kycLogData, users, type });
  };

  private goAlert = async () => {
    const { search } = this.state;
    const { router } = this.props;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const id: string | null = previousSearchParams.get('id');
    const type: string | null = previousSearchParams.get('type');
    if (type == null || id == null) return;
    const endpoint = `kyc_${type.toLowerCase()}_log_${NavigationUtil.getTenant()}`;
    try {
      await this.watchlistService.goKycLog(endpoint, id);
    } catch (e) {
      console.error(e);
    }
    if (!search) {
      await this.getCustomerData();
      this.setState({ search: true });
    }
  };

  private assignAlert = async (e: FormicaSelectBoxItem) => {
    const { router } = this.props;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const type: string | null = previousSearchParams.get('type');
    const id: string | null = previousSearchParams.get('id');
    if (type == null || id == null) return;
    let value = e.value;
    if (e.value == 'Unassign') {
      value = '';
    }
    try {
      await this.watchlistService.assignAlert(type as WatchlistType, id, value);
      MessageUtil.success({
        summary: LanguageUtil.get({ id: 'pages.alert.kycAlert', defaultMessage: 'KYC Alert' }),
        detail: (
          <div>
            <b>{e.value}</b> {LanguageUtil.get({ id: 'pages.alert.assignedToAlert', defaultMessage: 'assigned to Alert' })}
          </div>
        ),
      });
    } catch (error) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.alert.kycAlert', defaultMessage: 'KYC Alert' }),
        detail: (
          <div>
            Assigning Alert to <b>{e.value}</b> failed.
          </div>
        ),
      });
      console.error(error);
    }
  };

  private getCustomerData = async () => {
    const { kycLogData } = this.state;
    try {
      const request = kycLogData?.request as WatchlistIndividualRequest;
      if (request?.phone != undefined || request?.email != undefined) {
        const body: CustomerRequest = {
          phone: request.phone,
          email: request.email,
          hideDetails: false,
          useCache: true,
        };
        const data = await this.watchlistService.customerLookup(body);
        if (data) {
          this.setState({ customerData: data, customerLoading: false });
        }
      } else {
        this.setState({ customerLoading: false });
      }
    } catch (e) {
      console.error(e);
      this.setState({ customerLoading: false });
    }
  };

  private getQuery = () => {
    const { router } = this.props;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const id: string | null = previousSearchParams.get('id');
    const type: string | null = previousSearchParams.get('type');
    if (type == null || id == null) return;
    const endpoint = `kyc_${type.toLowerCase()}_log_${NavigationUtil.getTenant()}`;
    const builder = query.QueryBuilder.select().where(eq('id', id)).from(endpoint);
    return builder.build();
  };

  protected getTabs = () => {
    const { kycLogData, type, customerData, customerLoading, watchlistResponse } = this.state;
    const { router } = this.props;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const alertId: string | null = previousSearchParams.get('id');

    const tabs = [
      {
        key: 'Information',
        label: LanguageUtil.get({ id: 'common.tabs.information', defaultMessage: 'Information' }),
        content: (
          <WatchlistInformationComponent
            selectedResponse={kycLogData?.results[kycLogData.results.length - 1]?.record?.records || []}
            watchlistResponse={watchlistResponse}
            type={type as WatchlistType}
          />
        ),
      },
      {
        key: 'News',
        label: LanguageUtil.get({ id: 'common.tabs.news', defaultMessage: 'News' }),
        content: <WatchlistNewsComponent />,
      },
      {
        key: 'Social Media',
        label: LanguageUtil.get({ id: 'common.tabs.socialMedia', defaultMessage: 'Social Media' }),
        content: <WatchlistAlertSocialMediaComponent socialMediaResponse={customerData} loading={customerLoading} />,
      },
      {
        key: 'History',
        label: LanguageUtil.get({ id: 'common.tabs.history', defaultMessage: 'History' }),
        content: <WatchlistAlertHistoryComponent histories={kycLogData?.results} alertId={alertId} type={type} />,
      },
      {
        key: 'Similar',
        label: LanguageUtil.get({ id: 'common.tabs.similar', defaultMessage: 'Similar' }),
        content: <WatchlistAlertRequestListComponent kycLogData={kycLogData} type={type} />,
      },
    ];

    if (alertId) {
      tabs.push({
        key: 'Audit',
        label: LanguageUtil.get({ id: 'common.tabs.audit', defaultMessage: 'Audit' }),
        content: <WatchlistAlertAuditComponent alertId={alertId} kycLogData={kycLogData} />,
      });
    }

    return tabs;
  };

  private closeKycLog = (status: AlertStatus) => {
    this.setState({
      status: status,
      alertCloseModalVisible: true,
    });
  };

  private getStatusItem = (status: AlertStatus | undefined) => {
    switch (status) {
      case AlertStatus.MATCH:
        return 'bg-[#FBE5E4] text-[#C34135]';
      case AlertStatus.NOT_MATCH:
        return 'bg-[#E8FBF1] text-[#027A48]';
      case AlertStatus.IN_REVIEW:
        return 'bg-[#DFEAFD] text-[#175CD3]';
      case AlertStatus.WAITING_FOR_REVIEW:
        return 'bg-[#F6F6F9] text-[#4F4F4F]';
    }
  };

  private getStatusText = (status: AlertStatus | undefined) => {
    if (status == undefined) return 'Unknown';
    switch (status) {
      case AlertStatus.MATCH:
        return LanguageUtil.get({ id: 'pages.alert.matched', defaultMessage: 'Marked as Matched' });
      case AlertStatus.NOT_MATCH:
        return LanguageUtil.get({ id: 'pages.alert.notMatched', defaultMessage: 'Marked as not Matched' });
      case AlertStatus.IN_REVIEW:
        return LanguageUtil.get({ id: 'pages.alert.inReview', defaultMessage: 'In Review' });
      case AlertStatus.WAITING_FOR_REVIEW:
        return LanguageUtil.get({ id: 'pages.alert.waitingForReview', defaultMessage: 'Waiting For Review' });
    }
    return status;
  };

  private getLists = async () => {
    try {
      const lists: WatchlistListsModel[] | undefined = await this.watchlistService.getLists();
      this.setState({ watchlistResponse: lists || [] });
    } catch (e) {
      console.error(e);
    }
  };

  private getCategory = () => {
    const { kycLogData } = this.state;
    if (kycLogData?.results == undefined) return;
    const categories: any[] = [];
    kycLogData.results &&
      kycLogData.results.length > 0 &&
      kycLogData.results[kycLogData.results.length - 1].record?.records?.forEach((response) => {
        categories.push(response.watchlistRecord.categories);
      });
    return _.uniqBy([].concat(...categories));
  };

  private getImage = () => {
    const { kycLogData, type } = this.state;
    if (kycLogData?.results) {
      if (type == 'Individual') {
        const images = kycLogData?.results[kycLogData?.results.length - 1]?.record?.records.filter(
          (record) => (record.watchlistRecord as WatchlistIndividualRecord).images && (record.watchlistRecord as WatchlistIndividualRecord).images.length > 0,
        );
        if (images != undefined && images.length > 0) {
          return (
            <img
              src={(images[0].watchlistRecord as WatchlistIndividualRecord).images[0]}
              alt='-'
              onClick={() => window.open((images[0].watchlistRecord as WatchlistIndividualRecord).images[0], '_blank')}
              className={
                'w-[60px] h-[60px] cursor-pointer border min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] object-cover'
              }
            />
          );
        }
        return <img src={'/icons/individual.svg'} alt='individual' />;
      } else {
        return <img src={'/icons/entity.svg'} alt='entity' />;
      }
    }
  };

  private getUserOptions = () => {
    const { users } = this.state;
    const userOptions: Array<any> = users.map((user) => ({ label: `${user.firstName} ${user.lastName}`, value: user.username }));
    return [{ label: LanguageUtil.get({ id: 'common.label.unassign', defaultMessage: 'Unassign' }), value: 'Unassign' }, ...userOptions];
  };
}

interface Props extends FormicaProps, ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  page: state.page as PageState,
  user: state.auth.user,
});
const mapDispatchToProps = {
  enterComponent,
  leaveComponent,
  clearPage,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  searchCriteriaVisible: boolean = false;
  reasonVisible: boolean = false;
  kycLogData: WatchlistAlertDomains | undefined;
  type: string = 'Individual';
  search: boolean = false;
  customerData: WatchlistCustomerDomains | undefined;
  customerLoading: boolean = true;
  watchlistResponse: WatchlistListsModel[] = [];
  commentModalVisible: boolean = false;
  alertCloseModalVisible: boolean = false;
  levelModalVisible: boolean = false;
  status: AlertStatus | undefined;
  date: string | undefined;
  users: User[] = [];
  commentCount: number = 0;
}

export default withFormica(connector(WatchlistAlertDetailComponent));
